// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixFloatField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = 0;
    }
    ReadValue(buffer) {
        this.Value = buffer.ReadSingle();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        buffer.WriteSingle(this.Value);
    }
}
